import { render, staticRenderFns } from "./SapNoticeForm.vue?vue&type=template&id=2c966843&scoped=true&"
import script from "./SapNoticeForm.vue?vue&type=script&lang=js&"
export * from "./SapNoticeForm.vue?vue&type=script&lang=js&"
import style0 from "./SapNoticeForm.vue?vue&type=style&index=0&id=2c966843&prod&lang=scss&scoped=true&"
import style1 from "./SapNoticeForm.vue?vue&type=style&index=1&id=2c966843&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c966843",
  null
  
)

export default component.exports